namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_extension_app, {
		
		Enter: {
			padding: '1rem',
		},
		No_extension: {
			padding: '1rem',
		},
		
	} )
	
}
